import { TAG_TOP_PREFIX } from './constants'
import { TAG_TOP_TYPE, type TagTopType } from './schemas'

export type TagTopEntry = {
  type: TagTopType | undefined
  // 접두어를 뗀 태그 본문. 접두어(대괄호)가 없으면 null
  cuttedTagTop: string | null
}

// tagTop 은 줄마다 태그 하나다. 예: "[쌍둥이] 소수와 분수" → { type: 'twin', cuttedTagTop: ' 소수와 분수' }
export const parseTagTops = (tagTop: string | null | undefined): TagTopEntry[] => {
  if (!tagTop) return []

  return tagTop.split('\n').map((line) => {
    const type = [...TAG_TOP_TYPE]
      .reverse()
      .find((candidate) => line.includes(TAG_TOP_PREFIX[candidate]))
    const prefixEnd = line.indexOf(']')
    return {
      type,
      cuttedTagTop: prefixEnd > -1 ? line.slice(prefixEnd + 1) : null,
    }
  })
}
